$.fn.TI500Filters = function() {
  let self = this
  let ti500_grid = $('.grid--postitem__tech-icon');

  $(this).find('.ti500-categories__item').click(function() {
    if ($(this).hasClass('--selected') && $(this).attr('value') != 'reset') {
      $(this).removeClass('--selected')
      $(this).closest('.filter-drawer__items').find('.ti500-categories__item[value="reset"]').addClass('--selected')
    } else {
      $(this).closest('.filter-drawer__items').find('.ti500-categories__item').removeClass('--selected')
      $(this).addClass('--selected');
    }
    var selector = '';
    $('.ti500-categories__list').each(function() {
      var selected = $(this).find('.--selected')
      if (selected.length > 0) {
        var tax = selected.attr('tax')
        var value = selected.attr('value')
        if (value != 'reset') {
          selector += '.filter-' + tax + '-' + value;
        }
      }
    })
    ti500_grid.fadeOut(300, function() {
      ti500_grid.removeClass('--no-results')
      if (selector != '') {
        if (ti500_grid.find(selector).length > 0) {
          ti500_grid.find('.grid__item').addClass('--hide')
          ti500_grid.find(selector).removeClass('--hide')
        } else {
          ti500_grid.addClass('--no-results')
        }
      } else {
        ti500_grid.find('.grid__item').removeClass('--hide')
      }
      ti500_grid.fadeIn(300);
    });
    $(this).closest('.filter-drawer').removeClass('--drawer-expanded')
  })


  return function() {
    $(window).on('resize orientationchange load', self.resize)
    return self
  }()
}
